import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService, ContextService } from 'src/app/services';

const kbyte = 1024;
const mbyte = kbyte * 1024;
const gbyte = mbyte * 1024;

@Component({
    selector: 'app-document-preview',
    templateUrl: './document-preview.component.html',
    styleUrls: ['./document-preview.component.scss'],
    standalone: false
})
export class DocumentPreviewComponent implements OnInit {
  url: string;

  @Input() versionId: number;
  @Input() width: number = 200;
  @Input() size: number = 0;
  @Input() description: string;

  @ViewChild('image') image: ElementRef;
  @ViewChild('wrapper') wrapper: ElementRef;

  constructor(private authService: AuthenticationService, private context: ContextService) { }

  ngOnInit(): void {
    this.url = `${this.context.serviceUrl}/Blob/Fiscal/${this.context.fiscalId}/ScaledImage/${this.versionId}?width=${this.width}&access_token=${this.authService.token}`;
  }

  ngAfterViewInit() {
    this.wrapper.nativeElement.style.width = `${this.width}px`;
    this.image.nativeElement.style.width = `${this.width}px`;
    this.image.nativeElement.style.maxHeight = `${this.width}px`;
  }

  get humanSize() {
    if (this.size < kbyte) {
      return `${this.size}`;
    } else if (this.size < mbyte) {
      return `${(this.size / kbyte).toFixed(1)}`;
    } else if (this.size < gbyte) {
      return `${(this.size / mbyte).toFixed(1)}`;
    } else {
      return `${(this.size / gbyte).toFixed(1)}`;
    }
  }

  get humanSizeSuffix() {
    if (this.size < kbyte) {
      return `byte`;
    } else if (this.size < mbyte) {
      return `kilobyte`;
    } else if (this.size < gbyte) {
      return `megabyte`;
    } else {
      return `gigabyte`;
    }
  }
}
